import { ISmartFieldBlur, ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { createPath } from "@odata/BindingContext";
import {
    ICompanyEntity,
    IPrSubmissionRegZecEntity,
    PrSubmissionRegZecEntity,
    RegZecEmployeeEntity,
    RegZecEmploymentEntity
} from "@odata/GeneratedEntityTypes";
import { CountryCode, PrSubmissionSubtypeCode, PrSubmissionTypeCode } from "@odata/GeneratedEnums";
import { SubmissionsFormViewForExtend } from "@pages/payroll/submission/SubmissionFormView";
import { isObjectEmpty } from "@utils/general";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";
import { defaultCityCode } from "./PrJmhzSubmission.utils";

class PrSubmissionRegZecFormView extends SubmissionsFormViewForExtend<IPrSubmissionRegZecEntity> {
    typeCode = PrSubmissionTypeCode.EmployeeRegistration;
    subTypeCode: PrSubmissionSubtypeCode = null;
    pathToEmployee = createPath(PrSubmissionRegZecEntity.Employee, RegZecEmployeeEntity.Employee);

    typeSpecificOnAfterLoad(isNew: boolean): Promise<void> {
        const { storage } = this.props;

        const entity = storage.getEntity();
        const promises: Promise<void>[] = [];

        if (isNew) {
            const company = storage.context.getCompany() as ICompanyEntity;
            entity.Company.Company = { Id: company.Id };

            // default city code async (we don't wait fot it)
            defaultCityCode(storage, createPath(PrSubmissionRegZecEntity.Employment, RegZecEmploymentEntity.CityCode));
        } else {
            // set local context for showing/hiding fields

        }

        return Promise.all([...promises, super.typeSpecificOnAfterLoad(isNew)]).then();
    }

    handleChange(e: ISmartFieldChange): void {
        const { storage } = this.props;

        super.handleChange(e);
        // keep after storage -> handleChange to have updated data
    }

    _lastLastName: string = null;
    handleLastNameBlur = (args: ISmartFieldBlur): void => {
        const { storage } = this.props;
        if (args.wasChanged && args.bindingContext.getPath() === RegZecEmployeeEntity.LastName) {
            const previousLastNameValue = this._lastLastName ?? storage.data.origEntity.Employee.LastName;
            const currentValue = storage.getValueByPath(createPath(PrSubmissionRegZecEntity.Employee, RegZecEmployeeEntity.BirthLastName));
            const lastName = storage.getValueByPath(createPath(PrSubmissionRegZecEntity.Employee, RegZecEmployeeEntity.LastName));
            if (!currentValue || currentValue === previousLastNameValue) {
                storage.setValueByPath(createPath(PrSubmissionRegZecEntity.Employee, RegZecEmployeeEntity.BirthLastName), lastName);
            }
            this._lastLastName = lastName;
        }
    };

    async handleBlur(args: ISmartFieldBlur): Promise<void> {
        this.handleLastNameBlur(args);
        return super.handleBlur(args);
    }

    onBeforeSave(data?: IPrSubmissionRegZecEntity): IPrSubmissionRegZecEntity {
        data = super.onBeforeSave(data);

        if (!isObjectEmpty(data.Employee.CzechAddress) && !data.Employee.CzechAddress?.CountryCode) {
            data.Employee.CzechAddress.CountryCode = CountryCode.CzechRepublic;
        }

        return data;
    }
}

export default withPermissionContext(PrSubmissionRegZecFormView);
